<template lang="">
  <div class="profile-navigation" :class="{ active: active }">
    <div class="open-container" @click="openMenu">
      <AkChevronDown class="open" />
    </div>
    <ul class="container mb-0 p-0">
      <div class="close-container" @click="closeMenu">
        <AkChevronDown class="close" />
      </div>
      <li @click="closeMenu">
        <router-link
          to="/user-profile"
          exact
          active-class="active"
          :class="{ active: $route.path === '/profile' }"
        >
          ملف المستخدم
        </router-link>
      </li>
      <li @click="closeMenu">
        <router-link :to="{ name: 'user_courses' }" active-class="active">
          كورساتي
        </router-link>
      </li>
      <li @click="closeMenu">
        <router-link :to="{ name: 'coursesList' }" active-class="active">
          جميع الكورسات
        </router-link>
      </li>
      <!-- <li @click="closeMenu">
        <router-link to="/user-profile/history" active-class="active">
          الآمان و تاريخ تسجيل الدخول
        </router-link>
      </li> -->
      <li @click="closeMenu">
        <router-link to="/user-profile/details-views" active-class="active">
          تفاصيل المشاهدات
        </router-link>
      </li>
      <li @click="closeMenu">
        <router-link to="/user-profile/bills" active-class="active">
          الفواتير
        </router-link>
      </li>
      <li @click="closeMenu">
        <router-link to="/user-profile/subscriptions" active-class="active">
          الاشتراكات
        </router-link>
      </li>
      <li @click="closeMenu">
        <router-link to="/user-profile/exams-results" active-class="active">
          نتائج الامتحانات
        </router-link>
      </li>
      <li @click="closeMenu">
        <router-link
          to="/user-profile/assignment-results"
          active-class="active"
        >
          نتائج الواجب
        </router-link>
      </li>
      <!-- <li @click="closeMenu">
        <router-link
          to="/user-profile/video-quiz-results"
          active-class="active"
        >
          نتائج كويز الفيديو
        </router-link>
      </li> -->
      <li @click="closeMenu" class="notifications">
        <router-link to="/user-profile/notifications" active-class="active">
          الاشعارات
        </router-link>
        <span class="count" v-if="numOfNotificationsNotRead > 0">
          {{ numOfNotificationsNotRead }}
        </span>
      </li>
      <li @click="closeMenu">
        <router-link to="/user-profile/level-indicator" active-class="active">
          مؤشر المستوى
        </router-link>
      </li>
    </ul>
  </div>
  <router-view />
</template>
<script>
import config from "@/services/config";
import { AkChevronDown } from "@kalimahapps/vue-icons";
import axios from "axios";
export default {
  name: "ProfileLayout",
  components: {
    AkChevronDown,
  },
  data() {
    return {
      active: false,
      numOfNotificationsNotRead: 0,
    };
  },
  methods: {
    openMenu() {
      this.active = true;
    },
    closeMenu() {
      this.active = false;
    },
    getNotifications() {
      axios
        .get(`${config.basURL}student/notification-list`, {
          headers: {
            auth: this.$store.state.userToken,
          },
        })
        .then((res) => {
          this.numOfNotificationsNotRead = res?.data?.results?.filter(
            (notification) => notification.is_read === false
          )?.length;
        })
        .catch((err) => {
          this.error = err?.response?.status
            ? err.response.status
            : err.message;
          console.log(err.message);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    removeActive() {
      if (window.innerWidth > 992) {
        this.active = false;
      }
    },
  },
  watch: {
    $route() {
      this.getNotifications();
    },
  },
  mounted() {
    this.getNotifications();
    window.addEventListener("resize", this.removeActive);
  },
};
</script>
<style scoped>
.profile-navigation {
  background-color: #000000;
  position: relative;
  min-height: 50px;
}
.profile-navigation svg {
  display: none;
}
.profile-navigation ul {
  list-style: none;
  background-color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  max-width: 100%;
}
.profile-navigation ul li {
  min-width: 50px;
  width: fit-content;
}
.profile-navigation ul li a {
  all: unset;
  padding: 15px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  display: block;
  transition: all 0.5s;
}
.profile-navigation ul li a.active,
.profile-navigation ul li a:hover {
  background-color: #f1c40f;
  color: #000000 !important;
  font-weight: bold;
}
.profile-navigation ul li.notifications {
  position: relative;
}
.profile-navigation ul li.notifications .count {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #f10f0f;
  color: #ffffff;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  font-size: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
/*  Media Queries */
@media (max-width: 992px) {
  .profile-navigation {
    min-height: 75px;
  }
  .profile-navigation svg {
    display: block;
    color: #fff;
    font-size: 2rem;
    cursor: pointer;
  }
  .profile-navigation.active .open-container {
    display: none;
  }
  .profile-navigation .open-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
  }
  .profile-navigation svg.close {
    rotate: 180deg;
  }
  .profile-navigation .close-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 0;
    cursor: pointer;
  }
  .profile-navigation ul {
    position: absolute;
    top: -120%;
    z-index: 50;
    opacity: 0;
    flex-direction: column;
    max-width: 100%;
    height: auto;
    overflow: hidden;
    transform: translateY(-100%);
    transition: all 0.2s ease-in-out;
  }
  .profile-navigation.active ul {
    opacity: 1;
    top: 0;
    transform: translateY(0);
    transition: all 0.2s ease-in-out;
  }
  .profile-navigation ul li {
    width: 100%;
    text-align: center;
  }
  .profile-navigation ul li.notifications .count {
    right: 45%;
    transform: translateX(100%);
  }
}
@media (max-width: 768px) {
  .profile-navigation ul li.notifications .count {
    right: 40%;
  }
}
</style>
